import { useMemo } from "react";
import CommonButton from "../../../components/commonButton";
import { Add01Icon } from "../../../assets/icons";
import { BankIcons } from "../../../utils/otherHelopers";
import StatusChip from "../../../components/statusChip/StatusChip";
import { routes } from "../../../routes/pageRoutes";
import { TableSearch } from "../../../components/form/Fields";
import CustomTable from "../../../components/table/CustomTable";

export default function List({
  data,
  isLoading,
  isInitialLoad,
  setCurrentPage,
  navigate,
  searchTerm,
  currentPage,
  setSearchTerm,
  setOpenAddbankModal,
  handleStatusToggle,
  handleEdit,
  canCreate,
  canUpdate,
  pagination,
}) {
  const columns = useMemo(
    () => [
      {
        id: "bank_name",
        header: "BANK NAME",
        cell: (_, row) => (
          <div className="d-flex align-items-center gap-2">
            {row?.logo ? (
              <img
                src={row.logo.url}
                alt={row.name}
                style={{
                  width: "32px",
                  height: "32px",
                  objectFit: "contain",
                  borderRadius: "4px",
                }}
              />
            ) : (
              BankIcons(row?.name)
            )}
            <span>{row.name}</span>
          </div>
        ),
      },
      {
        id: "total_branches",
        header: "BRANCH COUNT",
        cell: (_, row) => row.total_branches || "-",
      },
      {
        id: "status",
        header: "STATUS",
        cell: (_, row) => (
          <StatusChip
            bg={row?.is_active ? "success" : "danger"}
            pill
            title={row?.is_active ? "Active" : "Inactive"}
            className={canUpdate ? "cursor-pointer" : ""}
            onClick={(e) => {
              e.stopPropagation();
              if (canUpdate) {
                handleStatusToggle(row);
              }
            }}
          />
        ),
      },
    ],
    [canUpdate, handleStatusToggle],
  );

  const actionList = useMemo(
    () =>
      [
        {
          title: "View",
          handler: (row) => {
            navigate(routes.viewBanksDetail.replace(":id", row.id), {
              state: { id: row?.id, currentPage: currentPage },
            });
          },
        },
        canUpdate && {
          title: "Edit",
          handler: (row) => {
            handleEdit(row);
          },
        },
        canUpdate && {
          title: (row) => (row.is_active ? "Deactivate" : "Activate"),
          handler: (row) => {
            handleStatusToggle(row);
          },
        },
      ].filter(Boolean),
    [canUpdate, handleEdit, handleStatusToggle, navigate, currentPage],
  );

  const isTableLoading = !isInitialLoad && isLoading;

  return (
    <>
      <div className="p-4 d-flex align-items-center justify-content-between gap-4">
        <TableSearch
          value={searchTerm}
          placeholder="Search by Bank Name"
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
        />
        {canCreate && (
          <CommonButton
            onClick={() => setOpenAddbankModal(true)}
            icon={
              <Add01Icon
                height={14}
                width={14}
                color="#ffffff"
                strokeWidth="3"
              />
            }
            title="Add Bank"
            variant="primary"
          />
        )}
      </div>

      <CustomTable
        data={data}
        columns={columns}
        loading={isTableLoading}
        keyField="id"
        emptyMessage="No banks found"
        actionList={actionList}
        rowClick={(row) => {
          navigate(routes.viewBanksDetail.replace(":id", row.id), {
            state: { id: row?.id, currentPage: currentPage },
          });
        }}
        pagination={pagination}
      />
    </>
  );
}
